import { render, createVNode } from 'vue'
import ToastConstructor from './BaseToast.vue'

let globalConfig = {
  transition: 'toast',
  duration: 7000,
  title: '',
  message: '',
  closeable: true
}
let seed = 1
class Toast {
  constructor(options) {
    globalConfig = Object.assign({}, globalConfig, options)
  }

  show(text, config = {}) {
    let [toastWrapper, toastVM] = [null, null]
    const id = 'base-toast_' + seed++
    toastWrapper = document.createElement('div')
    toastWrapper.id = id
    toastVM = createVNode(ToastConstructor, { ...globalConfig, ...config, title: text, id }, null)
    render(toastVM, toastWrapper)
    document.body.appendChild(toastWrapper)
  }
}

export default Toast
